




















import Vue from 'vue';
import { PipelineMenu } from '@/components/ds';
import AdmissionAccountEmail from '@/components/profile/AdmissionAccountEmail.vue';
import steps from '@/pipeline/steps';
import i18n from '@/i18n';
import pipeline from '@/pipeline';
import { AdmissionType } from '@/pipeline/stateMachine';
import Analytics from '@/helpers/analytics/analytics';
import { showEqualWebDrawer } from '@/helpers/accessibility';

interface PipelineItem {
  title: string;
  steps: string[];
  childrenActive: boolean;
  children: { title: string; steps: string[]; hidden?: boolean }[];
}

export default Vue.extend({
  components: { PipelineMenu, AdmissionAccountEmail },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { pipelineItems: [] as PipelineItem[], currentStep: '', stepHistory: [] as string[] };
  },
  mounted() {
    const forceTrigger = pipeline.initialized;
    pipeline.addTransitionListener(this.onPipelineUpdate, forceTrigger);
  },
  beforeDestroy() {
    pipeline.removeTransitionListener(this.onPipelineUpdate);
  },
  methods: {
    goToStep(step: string) {
      if (pipeline.initialized) pipeline.goTo(step);
    },
    onPipelineUpdate() {
      if (!pipeline.initialized) return;

      const courseItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.course'),
        childrenActive: false,
        steps: [steps.courseSelection],
        children: [],
      };

      const cityAndCampusItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.cityAndCampus'),
        childrenActive: false,
        steps: [steps.citySelection, steps.campusSelection],
        children: [
          { title: i18n.t('pipelineMenuOptions.citySelection'), steps: [steps.citySelection] },
          {
            title: i18n.t('pipelineMenuOptions.campusSelection'),
            steps: [steps.campusSelection],
          },
        ],
      };

      const admissionTypeItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.admissionType'),
        childrenActive: false,
        steps: [steps.admissionType.selection],
        children: [],
      };

      const admissionProcessItem: PipelineItem = {
        title: i18n.t('pipelineMenuOptions.admissionProcess'),
        childrenActive: false,
        steps: [null as any],
        children: [],
      };

      const contextAdmissionType: AdmissionType = pipeline.state?.context.admissionType;

      if (contextAdmissionType === 'enem') {
        admissionProcessItem.steps = Object.values(steps.admissionType.enem);
        admissionProcessItem.children = [
          {
            title: i18n.t('pipelineMenuOptions.enem.yearSelection'),
            steps: [steps.admissionType.enem.yearSelection],
          },
          {
            title: i18n.t('pipelineMenuOptions.enem.subscriptionNumber'),
            steps: [steps.admissionType.enem.subscriptionNumber],
          },
          {
            title: i18n.t('pipelineMenuOptions.enem.grades'),
            steps: [steps.admissionType.enem.grades],
          },
        ];
      } else if (contextAdmissionType === 'essay') {
        admissionProcessItem.steps = Object.values(steps.admissionType.essay);
        admissionProcessItem.children = [
          {
            title: i18n.t('pipelineMenuOptions.essay.themeSelection'),
            steps: [steps.admissionType.essay.themeSelection],
          },
          {
            title: i18n.t('pipelineMenuOptions.essay.supportText'),
            steps: [steps.admissionType.essay.supportText],
          },
          {
            title: i18n.t('pipelineMenuOptions.essay.write'),
            steps: [steps.admissionType.essay.write],
          },
        ];
      } else if (contextAdmissionType === 'secondGraduation') {
        admissionProcessItem.steps = Object.values(steps.admissionType.secondGraduation);
        admissionProcessItem.children = [
          {
            title: i18n.t('pipelineMenuOptions.secondGraduation.institutionInfo'),
            steps: [steps.admissionType.secondGraduation.institutionInfo],
          },
        ];
      } else if (contextAdmissionType === 'transferGraduation') {
        admissionProcessItem.steps = Object.values(steps.admissionType.transferGraduation);
        admissionProcessItem.children = [
          {
            title: i18n.t('pipelineMenuOptions.transfer.institutionInfo'),
            steps: [steps.admissionType.transferGraduation.institutionInfo],
          },
          {
            title: i18n.t('pipelineMenuOptions.transfer.documentation'),
            steps: [steps.admissionType.transferGraduation.documentation],
          },
        ];
      }

      this.pipelineItems = [courseItem, cityAndCampusItem, admissionTypeItem, admissionProcessItem];
      this.currentStep = pipeline.currentStep;
      this.stepHistory = pipeline.state.context.history || [];
    },
    onAccessibilityButtonClick() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
